export const textOverflow = {
  overflow: `hidden`,
  textOverflow: `ellipsis`,
  whiteSpace: `nowrap`
};

export const flex = {
  display: `flex`,
  flexDirection: `column`,
  flexWrap: `nowrap`,
  width: `auto`,
  height: `auto`,
  boxSizing: `border-box`,
  "> *": {
    textOverflow: `ellipsis`
  },
  "> :not(:first-child)": {
    marginTop: `0px`
  }
};

export const flexHorizontal = {
  ...flex,
  flexDirection: `row`
};

export const flexGrow = {
  "> *": {
    flexGrow: `0`
  }
};

export function flexGap(gap: string) {
  return {
    gap
  };
}

export const flexDisableShrink = {
  "> *": {
    flexShrink: `0`
  }
};

export const flexItem = {
  height: `auto`,
  width: `auto`,
  flexShrink: `1`
};

export const flexItemDisableShrink = {
  flexShrink: `0`
};

export const flexItemShrink = {
  flexShrink: `1`
};

export const flexItemGrow = {
  flexGrow: `1`
};
